import { Component, Input, OnDestroy } from '@angular/core';
import { DialogOpenService } from '@shared/services/dialog-open.service';

@Component({
  selector: 'app-dialog-layout',
  templateUrl: './dialog-layout.component.html',
  styleUrls: ['./dialog-layout.component.scss'],
})
export class DialogLayoutComponent implements OnDestroy {
  @Input() public showFooter = true;

  constructor(private dialogOpenService: DialogOpenService) {
    this.dialogOpenService.open();
  }

  public ngOnDestroy(): void {
    this.dialogOpenService.close();
  }
}
